import { Button, Stack, useTheme } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

function LanguageBtn() {
  const theme = useTheme();
  const { currentLang, onChangeLang } = useLocales();
  const isKo = currentLang.value === 'ko';

  const handleChange = (newLang) => {
    onChangeLang(newLang);
  };
  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Button
        sx={{
          width: 80,
          pr: 4,
          pl: 2,
          clipPath: 'polygon(0 0, 100% 0, 70% 100%, 0 100%)',
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0,
          mr: -1.5,
          border: '1px solid #000',
          borderRight: 'none',
          ...(isKo && {
            background: theme.palette.primary.main,
            '&:hover': {
              background: theme.palette.primary.main,
            },
          }),
        }}
        startIcon={<Iconify icon="emojione:flag-for-south-korea" />}
        onClick={() => handleChange('ko')}
      >
        Ko
      </Button>
      <Button
        sx={{
          width: 80,
          pl: 4,
          pr: 2,
          clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0 100%)',
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          ml: -1.5,
          border: '1px solid #000',
          borderLeft: 'none',
          ...(!isKo && {
            background: theme.palette.primary.main,
            color: '#fff',
            '&:hover': {
              background: theme.palette.primary.main,
            },
          }),
        }}
        startIcon={<Iconify icon="emojione:flag-for-united-kingdom" />}
        onClick={() => handleChange('en')}
      >
        En
      </Button>
    </Stack>
  );
}

export default LanguageBtn;
